import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react'
import styles from './ProfileCard.module.scss'

export default function ProfileCard({ user }) {
  useInterfaceLanguage();
  const fullName   = [user?.surName, user?.firstName, user?.lastName].filter(Boolean).join(' ')
  const initials   = [user?.firstName?.[0], user?.surName?.[0]].filter(Boolean).join('').toUpperCase()
  const position   = user?.position || tr("Сотрудник")
  const phone      = user?.numberPhone || user?.number_phone || '—'
  const department = user?.department || user?.department_name || null
  const photoSrc   = user?.imeag || user?.image || null

  const [imgErr, setImgErr] = useState(false)
  const showPhoto = photoSrc && !imgErr

  return (
    <div className={styles.card}>
      <div className={styles.avatar} style={showPhoto ? { background: 'transparent', padding: 0 } : undefined}>
        {showPhoto
          ? <img src={photoSrc} alt={tr(fullName)} className={styles.avatarImg} onError={() => setImgErr(true)} />
          : (initials || '👤')
        }
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{tr(fullName || '—')}</p>
        <div className={styles.badgeRow}>
          <span className={styles.positionBadge}>{tr(position)}</span>
          {tr(department && <span className={styles.deptBadge}>{tr(department)}</span>)}
        </div>
      </div>
      <div className={styles.meta}>
        <div className={styles.metaItem}>
          <span className={styles.metaIcon}>📞</span>
          <div className={styles.metaText}>
            <span className={styles.metaLabel}>{tr("Телефон")}</span>
            <span className={styles.metaValue}>{tr(phone)}</span>
          </div>
        </div>
        {tr(department && (
          <div className={styles.metaItem}>
            <span className={styles.metaIcon}>🏢</span>
            <div className={styles.metaText}>
              <span className={styles.metaLabel}>{tr("Отдел")}</span>
              <span className={styles.metaValue}>{tr(department)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
